import { all } from 'redux-saga/effects';
import { watchQuestionnaireActions } from '../container/Questionnaire/saga';

export default function* rootSaga(): any {
  yield all([
    watchQuestionnaireActions(),
  ]);
}
